import { Checkbox, Grid, TextField, Typography, Zoom, Tooltip } from "@material-ui/core";
import React, { useEffect } from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import { VendorCreateState } from "../../../reducers/vendor/VendorCreateReducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { VendorDetailState } from "../../../reducers/vendor/VendorDetailReducer";
import { Common } from "../../../utils/Common";
import { FormUtil } from "../../../utils/FormUtil";
import { VendorCategoryData } from "../../../constants/AppConstants";

export default function Form1Data(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    getErrorState,
    handleChange,
    prepareForRequest,
    compeleteRequest,
    isDisplayRegistrationNumber,
    getCompareField
  } = props;

  const createVendor: VendorCreateState = useSelector<
    RootState,
    VendorCreateState
  >((state) => state.vendorCreateDetails);

  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  // const getRequestSavedData = () => {
  //   prepareForRequest();
  //   VendorCreateService.getVendorRequestData(
  //     vendorDetail.RequestNumber,
  //     true,
  //     function (vendorRequestData: VendorCreateState) {
  //       dispatch({
  //         type: "ON_SUCCESS_VENDOR_REQUEST_GET",
  //         payload: vendorRequestData,
  //       });
  //       compeleteRequest(true);
  //     },
  //     function (error: Error) {
  //       console.log(error);
  //       compeleteRequest(false);
  //     }
  //   );
  // };

  // useEffect(() => {
  //   getRequestSavedData();
  // }, []);

  const concateDataList = (datalist: any) => {
    if (datalist && datalist.length > 0) {
      let concatstring = datalist.join(",");
      return concatstring;
    }
    return "";
  };

  return (
    <div>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        className={classes.formOneWrapper}
      >

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_requstor_lbl}
              <label hidden={getCompareField(vendorDetail.ReconAC)} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {createVendor.Requestory}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_department_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {createVendor.DepartmentName}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_comment_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {createVendor.Comment}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_companycode_lbl}
              <label hidden={getCompareField("VendorCompanyCodes")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {createVendor.CompanyCode}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_purchorg_lbl}
              <label hidden={getCompareField("PoCodes")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {concateDataList(createVendor.PoCodes)}
            </span>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_vendor_nominated_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {`${createVendor.VendorNominatedBy} - ${createVendor.vendorNominatedByDesc}`}
            </span>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_vendor_no_lbl}
              <label hidden={getCompareField("VendorNo")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {createVendor.vendorNo}
            </span>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_vendornm_lbl}
              <Tooltip TransitionComponent={Zoom} title="Add">
                <label hidden={getCompareField("Form1VendorName")} className={classes.editedLabel}>EDITED</label>
              </Tooltip>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {createVendor.VendorName}
            </span>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_vendortype_lbl}
              <label hidden={getCompareField("vendorTypeDesc")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {`${createVendor.vendorTypeDesc}`}
            </span>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_vendorCategory_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {`${createVendor.VendorCategory}`}
            </span>
          </Grid>
        </Grid>
        {createVendor.RMCategoryNames && createVendor.RMCategoryNames.length > 0 && (
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_crete_form1_RMCategory_lbl}
                 <label hidden={getCompareField("RMCategories")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid
              className={classes.formOneinputWrapper}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <span className={classes.textWrap}>
                {`${createVendor.RMCategoryNames}`}
              </span>
            </Grid>
          </Grid>)}
        {/* { (createVendor.VendorCategoryId == VendorCategoryData.NonRM || createVendor.VendorCategoryId == VendorCategoryData.Services) && (
          <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_spend_managed_by_lbl}              
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.textWrap}>
              {`${createVendor.SpendManagedByName}`}
            </span>
          </Grid>
        </Grid>
        )} */}
        {createVendor.ProcurementSubcategoryNames && createVendor.ProcurementSubcategoryNames.length > 0 && (
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_crete_form1_procurement_cat_lbl}
              </span>
            </Grid>
            <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.textWrap}>
                {`${createVendor.ProcurementSubcategoryNames}`}
              </span>
            </Grid>
          </Grid>)}
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_OnBoard_Reason_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {`${createVendor.OnBoardReasonNames}`}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_OBRDescript_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {`${createVendor.OnBoardReasonDescription}`}
            </span>
          </Grid>
        </Grid>
        {createVendor.VendorCategoryId == VendorCategoryData.RM && (
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_crete_form1_BulkSample_lbl}
              </span>
            </Grid>
            <Grid className={classes.formOneinputWrapper}
              item xs={12} sm={12} md={12} lg={12} >
              <span className={classes.textWrap}>
                {createVendor.IsBulk && <p>Bulk.</p>}
                {!createVendor.IsBulk && <p>Sample.</p>}
              </span>
            </Grid>
          </Grid>)
        }
        {!Common.isVendor() && (<Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_recon_lbl}
              <label hidden={getCompareField("ReconAcc")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper}
            item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {`${createVendor.reconACDesc}`}
            </span>
          </Grid>
        </Grid>)}

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_subcategory_lbl}
              <label hidden={getCompareField("SecondaryLevelCategoryCode")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper}
            item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {`${createVendor.TypeSubCategory} - ${createVendor.typeSubCategoryDesc}`}
            </span>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_mobilenum_diply_lbl}
              <label hidden={getCompareField("MobileNumber")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper}
            item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {createVendor.MobileNumber}
            </span>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_email_lbl}
              <label hidden={getCompareField("Email")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper}
            item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {createVendor.Email}
            </span>
          </Grid>
        </Grid>
        {/* //New change */}
        {(createVendor.TemporaryApprovalDays != null && createVendor.TemporaryApprovalDays != 0) && (
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_crete_form1_temporaryapprovaldays_lbl}
              </span>
            </Grid>
            <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
              <span className={classes.textWrap}>
                {createVendor.TemporaryApprovalDays}
              </span>
            </Grid>
          </Grid>
        )}
        {/* <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={6} sm={6} md={6} lg={6}>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={6}
            sm={6}
            md={6}
            lg={6}
          >  
           <span className={classes.textWrap}>
            </span>      
          </Grid>
        </Grid> */}

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_isforensup_lbl}
              <label hidden={getCompareField("IsForeignSupplier")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={6}
            sm={6}
            md={6}
            lg={6}
          >

            <span className={classes.textWrap}>
              <Checkbox
                checked={createVendor.isForeignSupplier}
                style={{ margin: "8px 0 0 0" }}
              />
            </span>

          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_crete_form1_vendorfillsform2_lbl}
              <label hidden={getCompareField("IsVendorFillForm2")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              <Checkbox
                checked={createVendor.IsVendorFillForm2}
                style={{ margin: "8px 0 0 0" }}
              />
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.dashboard_approve_isuserurgent}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              <Checkbox checked={createVendor.IsUrgentRequest} style={{ margin: "8px 0 0 0" }} />
            </span>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
